import { Component, EventEmitter, Input, Output, computed, input } from '@angular/core';
import { string } from 'purify-ts';
import { FormField } from 'src/app/shared/forms/abstract-form-field.directive';
import { FormContainerVM, FormFieldValue } from 'src/app/shared/forms/form-vm-container.directive';

@Component({
  selector: '[multipleRadiosDir]',
  templateUrl: './radio-button-group.component.html',
  styleUrls: ['./radio-button-group.component.scss']
})
export class RadioButtonGroupComponent extends FormField<string> {
  override value?: string | boolean | Date | null | undefined;
  updateModel(formVM: FormContainerVM, value: FormFieldValue): FormContainerVM {
   return {
    ...formVM,
    [this.name] : value
   }
  }
  @Input() label: string = '';
  @Input() bold: string = '';



  items = input<{
    value: string,
    label: string
  }[] | null>(null)

  itemsString = input<string[] | null>(null)

  _items  = computed( () => {
    if (this.items() != null) {
      return this.items()!
    }
    if (this.itemsString() != null) {
      return this.itemsString()!.map( i => ({
        value: i,
        label: i,
      }))
    }
    return [] as {value: string , label: string}[]
  })

  @Input() fontSize: number = 12;
  @Input() orientation: 'vertical' | 'horizontal' = 'horizontal'
  readonly type = 'radio'
  @Input() styleWidth100 = false; // controla se comp vai ocupar todo width disponivel (todo: mudar para nome melhor)
  @Input() required = false;
  @Input() valid = false;
  @Input() gap: string='';
  @Output() select = new EventEmitter<string>()


  override ngOnInit(): void {
    super.ngOnInit()
    this
  }

  onSelect(x: string) {
    this.model = x;

    this.select.emit(x)
  }

}
